import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import delle traduzioni
import translationIT from '../locales/it/translation.json';
import translationEN from '../locales/en/translation.json';

// Risorse di traduzione
const resources = {
  it: {
    translation: translationIT
  },
  en: {
    translation: translationEN
  }
};

// Inizializzazione di i18next
const i18nInitialized = i18n
  .use(LanguageDetector) // Rileva automaticamente la lingua del browser
  .init({
    resources,
    fallbackLng: 'it', // Lingua di default
    debug: process.env.NODE_ENV === 'development',
    
    // Opzioni di rilevamento lingua
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    interpolation: {
      escapeValue: true // oppure false, dipende dalla tua sicurezza
    },

    // Namespace di default
    defaultNS: 'translation',
    ns: ['translation']
  });

export default i18n;
export { i18nInitialized, i18n };
